module.exports = __webpack_public_path__ + "static/media/SingleLegSquatMale.dea78800.svg";